import { FormikProvider, useFormik } from 'formik';
import React, { useState } from 'react';
import { Button } from './Button';
import { ModalContentWrapper } from './ModalContentWrapper';
import { TextInputField } from './TextInputField';

export interface DeclineModalProps<T> {
  open: boolean;
  title?: string | React.ReactNode | JSX.Element;
  onClose: () => void;
  onConfirm: (payload: T) => Promise<void> | void;
  buttonName?: string;
  formikField?: string;
  withReason?: boolean;
  className?: string;
}

export const DeclineModal = <T,>({
  open,
  onClose,
  onConfirm,
  title = 'Reject reason',
  buttonName = 'Unsuccessful',
  formikField = 'reject_reason',
  withReason = true,
  className,
}: DeclineModalProps<T>) => {
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      [formikField]: '',
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    onSubmit: async values => {
      setIsLoading(true);

      await onConfirm(values as T);
      setIsLoading(false);

      onClose();
    },
  });

  return (
    <ModalContentWrapper open={open} title={title} onClose={onClose} classes={{ title: className }}>
      <FormikProvider value={formik}>
        <form
          className="w-full flex flex-col justify-center space-y-6"
          onSubmit={e => e.preventDefault()}
        >
          {withReason && (
            <TextInputField
              name={formikField}
              label="Reason"
              placeholder="Some reason..."
              textarea
              className="resize-none"
            />
          )}
          <Button onClick={formik.submitForm} disabled={isLoading}>
            {buttonName}
          </Button>
        </form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
